import { createMuiTheme } from '@material-ui/core';

import palette from './palette';

const theme = createMuiTheme({
    palette,
});

export default theme;
